import { apiFetcher } from '@/api/api'
import { useUserInfo } from '@/api/request'
import { useCacheSWR } from '@/api/swrCache'
import { useAuth } from '@/provides/authProvider'
import useSWRMutation from 'swr/mutation'

//邀请都有奖－邀请人数及奖励查询
export function useInvitePrizeInfo () {
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/act/api/v1/invite/invitePrizeInfo'
      },
      {
        arg: {}
      }
    )
  }
  const result = useCacheSWR('useInvitePrizeInfo',fetcher,{dedupingInterval: 0})
  const invitePrizeData = result.data?.data
  return{
    ...result,
    invitePrizeData
  }
}

// 现金天天赚-返利总计查询
export function useGetPageActivityBetTaskTotal () {
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/act/api/v1/invite/getPageActivityBetTaskTotal'
      },
      {
        arg: {}
      }
    )
  }
  const result = useCacheSWR('useGetPageActivityBetTaskTotal',fetcher,{dedupingInterval: 0})
  const activityBetTaskData = result.data?.data
  return{
    ...result,
    activityBetTaskData
  }
}

// 邀请都有奖/存款大福利/现金天天赚－分享图/活动说明，规则查询
export function useBaseConfig () {
  const { data: userInfo } = useUserInfo()
  const argParams={ inviteeId: parseInt(userInfo?.inviteCode ?? '0') }
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/act/api/v1/invite/baseConfig'
      },
      {
        arg: argParams
      }
    )
  }
  const result = useCacheSWR('useBaseConfig'+JSON.stringify(argParams),fetcher,{dedupingInterval: 60 * 60 * 1000})
  const baseConfigData = result.data?.data
  return{
    ...result,
    baseConfigData
  }
}

//邀请都有奖－奖励配置信息查询
export function useInvitePrizeConfig () {
  const { data: userInfo } = useUserInfo()
  const argParams={ inviteeId: parseInt(userInfo?.inviteCode ?? '0') }
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/act/api/v1/invite/invitePrizeConfig'
      },
      {
        arg: {}
      }
    )
  }
  const result = useCacheSWR('useInvitePrizeConfig'+JSON.stringify(argParams),fetcher,{dedupingInterval: 60 * 60 * 1000})
  const prizeConfigData = result.data?.data
  return{
    ...result,
    prizeConfigData
  }
}

//邀请链接
export function useGetRegisterUrl () {
  const { token } = useAuth()
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/act/api/v1/invite/getRegisterUrl'
      },
      {
        arg: {}
      }
    )
  }
  const result = useCacheSWR('useGetRegisterUrl',token ? fetcher : null,{dedupingInterval: 60 * 60 * 1000})
  const {data} = result
  return{
    ...result,
    data
  }
}


// 存款大优惠－邀请人，被邀请人申请状态接口
export function useDepositConfigInfo () {
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/act/api/v1/invite/depositConfigInfo'
      },
      {
        arg: {}
      }
    )
  }
  const result = useCacheSWR('useDepositConfigInfo',fetcher,{dedupingInterval: 0})
  const depositConfigData = result.data?.data
  return{
    ...result,
    depositConfigData
  }
}

// 存款申请
export const useInviteDepositApply = () => {
  const params = {
    path: '/act/api/v1/invite/depositApply',
    type: 'post'
  }
  const result = useSWRMutation( params ,
    (params, arg: { arg: any }) => {
      return apiFetcher<any>(params, { ...arg })
    }
  )
  return { ...result }
}


// 存款大优惠－场馆及奖励类型接口
export function useGetInviteDepositVenuesV2() {
  const { token } = useAuth()
  const fetcher = () => {
    return apiFetcher(
      {
        path: '/act/api/v1/invite/depositVenues'
      },
      {
        arg:{}
      }
    )
  }
  const result = useCacheSWR('useGetInviteDepositVenuesV2', token ? fetcher : null, {
    dedupingInterval: 60 * 60 * 1000
  })
  
  const bonusType=result?.data?.bonusType
  return {
    bonusType,
    ...result,
  }
}

// 回收
export const useVenueRecycle = () => {
  const params = {
    path: '/game/api/v1/venue/recycle',
    type: 'post'
  }
  const result = useSWRMutation( params ,
    (params, arg: { arg: any }) => {
      return apiFetcher<any>(params, { ...arg })
    }
  )
  return { ...result }
}

// 获取vip周活动
export const useGetVipWeekInfo = () => {
  const params = {
    path: '/act/api/v1/vipWeek/VipWeekInfo',
    type: 'post'
  }
  const result = useSWRMutation( params ,
    (params, arg: { arg: any }) => {
      return apiFetcher<any>(params, { ...arg })
    }
  )
  return { ...result }
}